export default __webpack_public_path__ + "static/media/photo--sm--ayaka.9ff1db20.jpg";